import axios from 'axios'
import { sdk } from './sdk'
import { parseJwt } from '../utils/jwt'

const stage = process.env.REACT_APP_STAGE

export const getBaseUrl = (): string => {
  const query = new URLSearchParams(window.location.search)
  const sessionEnv = sessionStorage.getItem('env')
  const queryEnv = query.get('env')
  // since idendity is hosted only on prod we need to determine environment from query param or session storage
  //1st priority is query param, then session storage, then env
  const environment = queryEnv || sessionEnv || stage

  switch (environment) {
    case 'dev':
      return 'api-dev.sistemiv.com'
    case null:
      return 'api-dev.sistemiv.com'
    case 'test':
      return 'api-test.sistemiv.com'
    case 'staging':
      return 'api-staging.sistemiv.com'
    default:
      return 'api.sistemiv.com'
  }
}

export const portalUrl = `https://portal${stage && stage !== 'prod' ? `-${stage}` : ''}.sistemiv.com`
export const imageBase = `https://${getBaseUrl()}/iam/api/profile/picture`

export function getCookie(name: string) {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) return parts.pop()?.split(';').shift()
}

const axiosInstance = axios.create({
  baseURL: `https://${getBaseUrl()}/iam/api`,
  headers: {
    'Content-Type': 'application/json',
  },
})
axiosInstance.defaults.maxRedirects = 0

const fetchSession = async () => {
  const { data: session } = await sdk.toSession({
    tokenizeAs: 'sistemiv-dev',
  })
  localStorage.setItem('access_token', session.tokenized || '')
  return session.tokenized || ''
}

const authInterceptor = async (config: any) => {
  let token = localStorage.getItem('access_token')
  if (!token) {
    try {
      token = await fetchSession()
    } catch (error) {
      window.location.href = `${window.location.origin}/login`
      return Promise.reject(error)
    }
  } else {
    const jwtExpiresAt = parseJwt(token)?.exp
    const expiresAt = new Date(jwtExpiresAt * 1000)
    const now = new Date()
    if (expiresAt < now) {
      try {
        token = await fetchSession()
      } catch (error) {
        window.location.href = `${window.location.origin}/login`
        return Promise.reject(error)
      }
    }
  }

  if (config.headers) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
}

axiosInstance.interceptors.request.use(authInterceptor, (error: any) => Promise.reject(error))
axiosInstance.interceptors.response.use(
  (response) => {
    return response
  },
  async (error) => {
    if (error.response && [301, 302].includes(error.response.status)) {
      const redirectUrl = error.response.headers.location
      window.location.replace(redirectUrl)
    } else {
      return Promise.reject(error)
    }
  },
)

export default axiosInstance
